import React from 'react';

import { QuestionRatio, QuestionTypeV2 } from '../../../redux/types';
import TextQuestionEditor from '../TextQuestionEditor';

export type Props = {
  surveyId: number;
  sectionId?: number;
  question?: QuestionRatio;
  addQuestion?: (dq: Omit<QuestionRatio, 'id'>) => void
  updateQuestion?: (dq: QuestionRatio) => void
  onCancelEdit?: () => void;
  disableHideAggregation?: boolean;
}

const RatioQuestionEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  question,
  addQuestion,
  updateQuestion,
  onCancelEdit,
  disableHideAggregation,
}: Props) => (
  <TextQuestionEditor<QuestionRatio>
    type={QuestionTypeV2.Ratio}
    surveyId={surveyId}
    sectionId={sectionId}
    question={question}
    addQuestion={addQuestion}
    updateQuestion={updateQuestion}
    onCancelEdit={onCancelEdit}
    disableHideAggregation={disableHideAggregation}
  />
);

export default RatioQuestionEditor;
